import { useAuth } from '../../context/AuthContext';
import { ChevronDownIcon, Bars3Icon } from '@heroicons/react/24/outline';
import NotificationBell from '../NotificationBell';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const headerStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .t-header { height:60px; min-height:60px; background:#ffffff; border-bottom:1px solid #eaecf4; display:flex; align-items:center; justify-content:space-between; padding:0 24px; font-family:'Sora',sans-serif; flex-shrink:0; z-index:10; }
  .t-header-left { display:flex; align-items:center; gap:8px; }
  .t-header-breadcrumb { font-size:.8rem; color:#b0b5cc; font-weight:400; }
  .t-header-sep  { color:#d8dce8; font-size:.8rem; }
  .t-header-page { font-size:.82rem; color:#1a1d2e; font-weight:600; }
  .t-header-right { display:flex; align-items:center; gap:8px; }
  .t-icon-btn { width:36px; height:36px; border-radius:10px; border:1px solid #eaecf4; background:#f8f9fc; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:background .15s; position:relative; }
  .t-icon-btn:hover { background:#f0f2f8; }
  .t-icon-btn svg { width:17px; height:17px; stroke:#6b7194; stroke-width:1.7; }
  .t-divider { width:1px; height:24px; background:#eaecf4; margin:0 4px; }
  .t-user { display:flex; align-items:center; gap:10px; padding:5px 10px 5px 5px; border-radius:12px; cursor:pointer; transition:background .15s; border:1px solid transparent; }
  .t-user:hover { background:#f5f6fb; border-color:#eaecf4; }
  .t-avatar { width:32px; height:32px; border-radius:10px; background:linear-gradient(135deg,#10c98e,#3b6ef8); display:flex; align-items:center; justify-content:center; font-size:.75rem; font-weight:700; color:white; flex-shrink:0; }
  .t-user-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .t-user-role { font-size:.68rem; color:#9094a8; margin-top:2px; }
  .t-user svg { width:14px; height:14px; stroke:#b0b5cc; stroke-width:2; margin-left:2px; }
  .t-logout { padding:7px 14px; background:#fff1f1; color:#ef4444; border:1px solid #fecaca; border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .t-logout:hover { background:#fee2e2; }
  .t-hamburger { display:none; }
  @media (max-width:768px) {
    .t-header { padding:0 16px; }
    .t-hamburger { display:flex; }
    .t-header-breadcrumb, .t-header-sep { display:none; }
    .t-user-name, .t-user-role, .t-user svg { display:none; }
    .t-user { padding:4px; }
    .t-divider { display:none; }
    .t-logout { padding:6px 10px; font-size:.72rem; }
  }
`;

const getInitials = (name='') => name.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2) || 'T';

export const TeacherHeader = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Teacher';
  return (
    <>
      <style>{headerStyle}</style>
      <header className="t-header">
        <div className="t-header-left">
          <button className="t-icon-btn t-hamburger" onClick={onMenuClick} style={{border:'none',background:'transparent'}}>
            <Bars3Icon />
          </button>
          <span className="t-header-breadcrumb">School Portal</span>
          <span className="t-header-sep">/</span>
          <span className="t-header-page">Teacher</span>
        </div>
        <div className="t-header-right">

          {/* ── Notification Bell ── */}
          <NotificationBell />

          <div className="t-divider" />
          <div className="t-user">
            <div className="t-avatar">{getInitials(displayName)}</div>
            <div>
              <div className="t-user-name">{displayName}</div>
              <div className="t-user-role">Teacher</div>
            </div>
            <ChevronDownIcon />
          </div>
          <div className="t-divider" />
          <button className="t-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
};

export default TeacherHeader;